var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"button-done-sorting",attrs:{"color":"primary"},on:{"click":function($event){return _vm.$store.commit('toggleSorting')}}},[_vm._v(" Done Sorting ")])}
var staticRenderFns = []

export { render, staticRenderFns }